import {
  EVENT_DIRECTIONS,
  readEventDirections,
  type EventDirection,
} from '../../../constants/directions';

type PracticeCategoryItem = {
  category?: string | null;
  categories?: string[] | null;
};

/**
 * Converts both video-practice category contracts (the canonical array and
 * the legacy CSV field) into the value used by the live picker view-model.
 */
export function practiceCategoryValue(
  item: PracticeCategoryItem,
  fallback = '',
): string {
  const directions = readEventDirections(item);
  if (directions.length > 0) return directions.join(', ');
  return item.category?.trim() || fallback;
}

/** Only show filters that can match at least one loaded practice. */
export function availablePracticeCategories(
  items: readonly PracticeCategoryItem[],
): EventDirection[] {
  const present = new Set<EventDirection>();
  for (const item of items) {
    for (const direction of readEventDirections(item)) present.add(direction);
  }
  return EVENT_DIRECTIONS.filter((direction) => present.has(direction));
}

export function filterByPracticeCategory<T extends PracticeCategoryItem>(
  items: readonly T[],
  category: EventDirection | null,
): T[] {
  if (!category) return [...items];
  return items.filter((item) => readEventDirections(item).includes(category));
}
